import { useScrollReveal } from "@/hooks/useScrollReveal";
import HeroSection from "./components/HeroSection";
import StickyNavSection from "./components/StickyNavSection";
import ServiceOverviewSection from "./components/ServiceOverviewSection";
import ChallengesSection from "./components/ChallengesSection";
import AboutSection from "./components/AboutSection";
import MonthlyServiceSection from "./components/MonthlyServiceSection";
import MonthlyCycleSection from "./components/MonthlyCycleSection";
import FirstThreeMonthsSection from "./components/FirstThreeMonthsSection";
import ScopeSection from "./components/ScopeSection";
import PricingSection from "./components/PricingSection";
import ExamplesSection from "./components/ExamplesSection";
import WhoItIsForSection from "./components/WhoItIsForSection";
import FAQSection from "./components/FAQSection";
import RelatedServicesSection from "./components/RelatedServicesSection";
import CTASection from "./components/CTASection";

export default function DxAdvisoryPage() {
  useScrollReveal();

  return (
    <>
      <HeroSection />
      <StickyNavSection />
      <ServiceOverviewSection />
      <ChallengesSection />
      <AboutSection />
      <MonthlyServiceSection />
      <MonthlyCycleSection />
      <FirstThreeMonthsSection />
      <ScopeSection />
      <PricingSection />
      <ExamplesSection />
      <WhoItIsForSection />
      <FAQSection />
      <RelatedServicesSection />
      <CTASection />
    </>
  );
}